/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Dirs_Toast_Delete_SuccessInputs */

const es_settings_dirs_toast_delete_success = /** @type {(inputs: Settings_Dirs_Toast_Delete_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminado`)
};

const en_settings_dirs_toast_delete_success = /** @type {(inputs: Settings_Dirs_Toast_Delete_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleted`)
};

/**
* | output |
* | --- |
* | "Deleted" |
*
* @param {Settings_Dirs_Toast_Delete_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_dirs_toast_delete_success = /** @type {((inputs?: Settings_Dirs_Toast_Delete_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Dirs_Toast_Delete_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_dirs_toast_delete_success(inputs)
	return en_settings_dirs_toast_delete_success(inputs)
});
export { settings_dirs_toast_delete_success as "settings.dirs.toast.delete_success" }